import React from 'react';
import { connect } from 'react-redux';

import SmsSubscriptionTrigger from '../components/SmsSubscriptionTrigger';
import { profileUpdateRequest, smsSubscriptionFormLoad } from '../actions';

const mapStateToProps = (state, props) => ({
  isSubmitting:
    state.user.profileUpdateIsProcessing ||
    state.smsSubscription.SmsCreateIsProcessing,
  hideSmsSubscriptionForm: state.smsSubscription.hideSmsSubscriptionForm,
  statusMessage:
    state.user.statusMessage || state.smsSubscription.statusMessage,
  statusMessageError:
    state.user.statusMessageError || state.smsSubscription.statusMessageError,
});

const mapDispatchToProps = dispatch => ({
  onLoad: phone => {
    dispatch(smsSubscriptionFormLoad(phone));
  },
  onSubmit: phone => {
    dispatch(profileUpdateRequest(phone));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(
  SmsSubscriptionTrigger
);



// WEBPACK FOOTER //
// ./app/javascript/apps/sms_subscriptions/containers/SmsSubscriptionTrigger.js